/** Trophy catalog for Trophy Case UI — extends milestone badges. */

export const TROPHY_CATEGORIES = [
  { id: "all", label: "All" },
  { id: "membership", label: "Membership" },
  { id: "discovery", label: "Discovery" },
  { id: "streaks", label: "Streaks" },
  { id: "social", label: "Social" },
  { id: "creator", label: "Creator" },
  { id: "seasonal", label: "Seasonal" },
  { id: "secret", label: "Secret" },
];

export const TROPHY_CATALOG = [
  { key: "early_fan", name: "Early Fan", category: "membership", rarity: "rare", description: "Followed a creator before they hit 100 subscribers.", iconBg: "#FDF3E0", iconStroke: "#C4790A" },
  { key: "first_viewer", name: "First Viewer", category: "discovery", rarity: "rare", description: "Among the first 10 to view a drop.", iconBg: "#EAF2ED", iconStroke: "#1A8C52" },
  { key: "supporters_10", name: "Growing Circle", category: "creator", rarity: "common", description: "Reach 10 supporters.", iconBg: "#FDF3E0", iconStroke: "#C4790A" },
  { key: "supporters_50", name: "Community Builder", category: "creator", rarity: "rare", description: "Reach 50 supporters.", iconBg: "#FBEEE4", iconStroke: "#B55A1A" },
  { key: "supporters_100", name: "Century Club", category: "creator", rarity: "legendary", description: "Reach 100 supporters.", iconBg: "#FDF3E0", iconStroke: "#C4790A" },
  { key: "seven_day_streak", name: "7 Day Streak", category: "streaks", rarity: "common", description: "Visit the platform 7 days in a row.", iconBg: "#FBEEE4", iconStroke: "#C4790A" },
  { key: "thirty_day_streak", name: "30 Day Streak", category: "streaks", rarity: "rare", description: "Visit the platform 30 days in a row.", iconBg: "#FDF3E0", iconStroke: "#C4790A" },
  { key: "first_follow", name: "First Follow", category: "social", rarity: "common", description: "Follow your first creator.", iconBg: "#E4EDF5", iconStroke: "#3A5A7A" },
  { key: "wall_note", name: "Wall Writer", category: "social", rarity: "rare", description: "Send an Appreciation Wall note.", iconBg: "#E4F5EE", iconStroke: "#1A8C52" },
  { key: "pip_finder", name: "Pip Spotter", category: "secret", rarity: "legendary", description: "Find Pip hiding on the site.", iconBg: "#FDF3E0", iconStroke: "#C4790A", secret: true },
  { key: "canada_day", name: "Canada Day", category: "seasonal", rarity: "rare", description: "Active on Canada Day.", iconBg: "#FDEAEE", iconStroke: "#D03050" },
  { key: "founding_member", name: "Founding Member", category: "membership", rarity: "legendary", description: "Joined during the founding launch window.", iconBg: "#FDF3E0", iconStroke: "#C4790A" },
];

export function getTrophyByKey(key) {
  return TROPHY_CATALOG.find((t) => t.key === key);
}

export function getEarnedTrophies(user = {}) {
  const earnedKeys = new Set([
    ...(user.earnedMilestones || []),
    ...(user.earnedTrophies || []),
  ]);
  if (user.pinnedTrophy) earnedKeys.add(user.pinnedTrophy);
  return TROPHY_CATALOG.filter((t) => earnedKeys.has(t.key));
}
